var Backbone = require('backbone');
var _ = require('underscore');
var svg4everybody = require('svg4everybody');

//ie
require('es6-promise').polyfill();

var Settings = require('./Settings');
var Router = require('./Router');
var Utils = require('front/utils/Utils.js');

require('front/components/Content/Content');

var Footer = require('front/components/Footer/Footer');
var TopNav = require('front/components/TopNav/TopNav');

require('reset.css');
require('front/const.less');
require('front/style.less');
require('front/utils.less');
require('front/fonts.less');

svg4everybody();

app.configure = Settings.configure;
app.configure();

window.app.vent = _.extend({}, Backbone.Events);

window.app.utils = Utils;

window.app.cache = {};

window.app.state = {
};


window.app.els = {
    $window: $(window),
    $body: $('body'),
    $htmlBody: $('html,body'),
    $content: $('.Content'),
    $topNav: $('.TopNav')
};
app.router = new Router();

app.els.$body.on('click', '.u-Route', function (e) {
    if (app.els.$body.hasClass('Page404')) {
        return;
    }

    var currentRoute = Backbone.history.getFragment();

    var parentUrl = $(e.target)
        .closest('a')
        .attr('href');

    var url = $(e.currentTarget).attr('href') || parentUrl;


    /*if  ('/' + currentRoute === url) {
        // Если мы уже на этом роуте, то скролим вверх.
        e.preventDefault();
        app.els.$htmlBody.animate({scrollTop: 0});
    }
    else {*/
    e.preventDefault();
    Backbone.history.navigate(url, {trigger: 'true'});
    //}
});


app.views = {
    topNav: new TopNav(),
    footer: new Footer()
};

function csrfSafeMethod(method) {
    // these HTTP methods do not require CSRF protection
    return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
}

$.ajaxSetup({
    beforeSend: function (xhr, settings) {
        if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
            var csrftoken = Cookies.get('csrftoken');
            xhr.setRequestHeader('X-CSRFToken', csrftoken);
        }
    }
});


app.router.start();



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/App.js
// module id = 28
// module chunks = 0